import { render, staticRenderFns } from "./UsefulContacts.vue?vue&type=template&id=51411f97&scoped=true&"
import script from "./UsefulContacts.vue?vue&type=script&lang=js&"
export * from "./UsefulContacts.vue?vue&type=script&lang=js&"
import style0 from "./UsefulContacts.vue?vue&type=style&index=0&id=51411f97&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51411f97",
  null
  
)

export default component.exports